import { render, staticRenderFns } from "./editSenderProfilesForm.vue?vue&type=template&id=770731d0"
import script from "./editSenderProfilesForm.vue?vue&type=script&lang=js"
export * from "./editSenderProfilesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports